import comRichtext from '../../components/com-richtext.vue';
export default{
    name:'InformationDetail',
    data(){
        return{
            detail:{},
            breadTitle:'',
        }
    },
    created(){
        this.getDetail();
    },
    components:{
        comRichtext,
    },
    methods:{
        getDetail(){
            this.breadTitle=this.$route.query.type;
            var url=this.api.getFocusDetail;
            switch(this.breadTitle){
                // case '今日头条':
                //     url=this.api.getTopDetail;
                //     break;
                // case '焦点回顾':
                //     url=this.api.getFocusDetail;
                //     break;
                // case '企业资讯':
                //     url=this.api.getCompanyDetail;
                //     break;
                case '行业新闻':
                    url=this.api.getIndustryDetail;
                    break;
                case '政策法规':
                    url=this.api.getPolicyDetail;
                    break;
                case '信息通知':
                    url=this.api.getInformationNoticeDetail;
                    break;

            };
            var body={
                id:this.$route.query.id,
            };
            this.get(url,body).then(res=>{
                this.detail=res.data;
            }).catch();
            

        }
    }
}